<script>
import Vue from 'vue'
import VueI18n from 'vue-i18n'
import localeArg from './es-ar.json'
import localeEn from './en-gr.json'
import config from '../config/applicationConfig'

Vue.use(VueI18n)

let url = document.location.href
url = url.replace('#', '')
url = new URL(url)
let urlLocale = new URLSearchParams(url.search).get('locale')
console.log(urlLocale)

export default new VueI18n({
  locale: urlLocale !== null ? urlLocale : config.LOCALE,
  messages: {
    'es-ar': localeArg,
    'es-CO': localeArg,
    'es-mx': localeArg,
    'en-gr': localeEn
  }
})
</script>


// WEBPACK FOOTER //
// src/locales/Lang.vue